const announcementBar = document.querySelector(".announcement-bar__messages");

if (!window.dAgency) window.dAgency = {};
window.dAgency.initAnnouncementBar = () => {
  if (
    !announcementBar ||
    announcementBar.classList.contains("announcement-bar--marquee-loaded")
  )
    return;

  $(announcementBar).marquee({
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    duration: 22500,
    gap: 0,
    pauseOnHover: true,
    startVisible: true,
  });

  announcementBar.classList.add("announcement-bar--marquee-loaded");
};

document.addEventListener("DOMContentLoaded", function () {
  window.dAgency.initAnnouncementBar(announcementBar);
});
